import React, { Component } from 'react'
import classes from './Form.scss'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
// import Card from '../../../../UI/Card/Card'
// import CardHeader from '../../../../UI/Card/Header/Header'
// import CardBody from '../../../../UI/Card/Body/Body'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import { Delete, Add } from '@material-ui/icons'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import { SketchPicker } from 'react-color'
import Modal from '../../../../UI/Modal/Modal'
import Footer from '../../../..//UI/Modal/Footer/Footer'
// import OpacityIcon from '@material-ui/icons/Opacity'
import ColorLensIcon from '@material-ui/icons/ColorLens'
class form extends Component {
  state = {
    form: [],
    modalOpen: false,
    color: '#000000'
  }

  static getDerivedStateFromProps = (props, state) => {}

  closeModal = () => {
    this.setState({
      modalOpen: false,
      color: '#000000'
    })
  }
  handleChangeColor = color => {
    this.setState({ color: color.hex })
  }
  selectColor = () => {
    this.props.groupsChanged('color_code', this.state.color)
    this.closeModal()
  }
  render() {
    let tabContent = null
    tabContent = Object.entries(this.props.form).map(res => {
      let [key, attr] = res
      let inputtt = null
      if (key === 'thresholds') {
        inputtt = Object.entries(this.props.groups).map(input => {
          let [inputKey, inputAttr] = input

          return (
            // <Grid container direction='row' justify='space-around' alignItems='center'>
            <Aux>
              {/* <div className={classes.InputtGroup}> */}
              <Grid item xs={inputKey === 'color_code' ? 10 : 12} sm={3}>
                <InputGroup
                  key={inputKey}
                  label={inputAttr.label}
                  inputType={inputAttr.elementType}
                  configs={inputAttr.elementConfig}
                  invalid={!inputAttr.valid}
                  validations={inputAttr.validation}
                  touched={inputAttr.touched}
                  changed={e => this.props.groupsChanged(inputKey, e)}
                  inputValue={inputAttr.value}
                  validationError={inputAttr.error}
                />
                {/* <div className={classes.InputtGroup}> */}
                {/* </div> */}
              </Grid>
              {/* {inputKey === 'color_code' ? (
                  <label
                  style={{ color: inputAttr.value }}
                  className={classes.inputColorLabel}
                  for='input-color'>
                  <ColorLensIcon fontSize='large' />
                  </label>
                ) : null} */}
              {inputKey === 'color_code' ? (
                <Grid item xs={2}>
                  {/* <input
                    type='color'
                    id='input-color'
                    style={{
                      opacity: 0,
                      position: 'absolute',
                      width: '0px',
                      padding: 0,
                      margin: 0
                    }}
                    value={inputAttr.value}
                    onChange={e => this.props.groupsChanged(inputKey, e)}
                  /> */}
                  <IconButton
                    size='small'
                    onClick={() => this.setState({ modalOpen: true, color: inputAttr.value })}>
                    <ColorLensIcon style={{ color: inputAttr.value }} fontSize='large' />
                  </IconButton>
                </Grid>
              ) : null}
              {/* </div> */}
            </Aux>
            // </Grid>
          )
        })

        if (attr.value) {
          return (
            <div>
              {this.props.translate(key)}
              <Grid container>
                <Grid item xs={12}>
                  <Grid container direction='row' justify='space-around' alignItems='center'>
                    <Grid item xs={12} sm={10}>
                      <Grid container direction='row' justify='space-around' alignItems='center'>
                        {inputtt}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <IconButton size='small' onClick={e => this.props.addGroup()}>
                        <Add />
                      </IconButton>
                      <IconButton size='small' onClick={e => this.props.delGroup()}>
                        <Delete />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{this.props.translate('start')}</TableCell>
                        <TableCell>{this.props.translate('end')}</TableCell>
                        <TableCell>{this.props.translate('color')}</TableCell>
                        <TableCell>{this.props.translate('action')}</TableCell>
                      </TableRow>
                    </TableHead>
                    {attr.value ? (
                      <TableBody>
                        {attr.value.map(row => (
                          <TableRow key={row.threshold_id}>
                            <TableCell>{row.start_value}</TableCell>
                            <TableCell>{row.end_value}</TableCell>
                            <TableCell>
                              <div>
                                {row.color_code}
                                <div
                                  style={{
                                    backgroundColor: row.color_code,
                                    width: '50%',
                                    height: '20px'
                                  }}></div>
                              </div>
                            </TableCell>
                            <TableCell>
                              <IconButton size='small' onClick={e => this.props.delCell(row)}>
                                <Delete />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    ) : null}
                  </Table>
                </Grid>
              </Grid>
            </div>
          )
        } else {
          return (
            <div>
              {key}
              <Grid container>
                <Grid item xs={12}>
                  <Grid container direction='row' justify='space-around' alignItems='center'>
                    <Grid item xs={12} sm={10}>
                      <Grid container direction='row' justify='space-around' alignItems='center'>
                        {inputtt}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <IconButton size='small' onClick={e => this.props.addGroup()}>
                        <Add />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{this.props.translate('start')}</TableCell>
                        <TableCell>{this.props.translate('end')}</TableCell>
                        <TableCell>{this.props.translate('active')}</TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </Grid>
              </Grid>
            </div>
          )
        }
      } else {
        return (
          <InputGroup
            key={key}
            label={attr.label}
            inputType={attr.elementType}
            configs={attr.elementConfig}
            invalid={!attr.valid}
            validations={attr.validation}
            touched={attr.touched}
            changed={e => this.props.inputChanged(key, e)}
            inputValue={attr.value}
            validationError={attr.error}
          />
        )
      }
    })
    let footer = (
      <Footer
        save={() => this.selectColor()}
        showAnother={false}
        cancel={() => this.closeModal()}
        disable={false}
      />
    )
    return (
      <div className={classes.Form}>
        {tabContent}
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate('colorCode')}
          disableBackdropClick={true}
          size={'xs'}
          footer={footer}>
          <Grid container direction='row' justify='space-around' alignItems='center'>
            <SketchPicker color={this.state.color} onChangeComplete={this.handleChangeColor} />
          </Grid>
        </Modal>
      </div>
    )
  }
}

export default withTranslate(form)
